module.exports = __webpack_public_path__ + "static/media/post-img8.df2fd549.jpg";